import { get } from "../GenericServices";

const ProjectType = {
  getProjectType: (queryString) => {
    return get(`project-type?${queryString}`);
  },
};

export default ProjectType;
